import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SearchTabletPage } from './Tablet/search';
import { SearchPhoneStartPage } from './Phone/SearchPhoneStartPage';
import { SearchPhoneSelectListPage } from './Phone/SearchPhoneSelectListPage';



import {ComponentsModule} from "../../components/components.module"

@NgModule({
  declarations: [
    SearchTabletPage,
	SearchPhoneStartPage,
	SearchPhoneSelectListPage
  ],
  imports: [
    IonicPageModule.forChild(SearchTabletPage),
    IonicPageModule.forChild(SearchPhoneStartPage),
    IonicPageModule.forChild(SearchPhoneSelectListPage),
	ComponentsModule
  ],
})
export class SearchPageModule {}



// WEBPACK FOOTER //
// ./src/pages/search/search.module.ts